import {
  QuoteNavigation,
  MobileNavigation,
  MemoizedUserNavigation,
} from "../sections/Navigation";
import Footer from "../sections/Footer";
import "./Mobile.css";

function Mobile(props) {
  var quoteNavigation;
  var mobileNav;
  var footer;
  var classes = "quote-navigation " + props.quoteNavClasses;
  var lastPage = "BACK TO " + props.lastPage;
  var mobileNavColor = props.mobileNavColor;

  if (props.showQuoteNavigation) {
    quoteNavigation = (
      <QuoteNavigation
        back={props.back}
        lastPage={lastPage}
        classes={classes}
        textClasses={props.quoteNavTextClasses}
        arrowClasses={props.arrowClasses}
      />
    );
  }

  if (props.showMobileNav) {
    mobileNav = <MobileNavigation color={mobileNavColor} />;
  }

  if (props.showFooter) {
    footer = <Footer />;
  }

  return (
    <main className="h-100" id="main-content">
      {quoteNavigation}
      <div
        className={`flex-wrapper-space-between ${
          props.genericContainer === true ? "generic-container" : ""
        }`}
      >
        {props.body}
        {footer}
      </div>
    </main>
  );
}

export default Mobile;
